import React, {Component} from 'react';

import './styles.scss';
import {getRapidNaming, getNormingRapidNaming} from 'constants/tests.js';

import grabamse from 'assets/images/rapidNaming/grabamse.png';
import gragenser from 'assets/images/rapidNaming/gragenser.png';
import graeple from 'assets/images/rapidNaming/graeple.png';
import gratommel from 'assets/images/rapidNaming/gratommel.png';
import grasykkel from 'assets/images/rapidNaming/grasykkel.png';

import blabamse from 'assets/images/rapidNaming/blabamse.png';
import blagenser from 'assets/images/rapidNaming/blagenser.png';
import blaeple from 'assets/images/rapidNaming/blaeple.png';
import blatommel from 'assets/images/rapidNaming/blatommel.png';
import blasykkel from 'assets/images/rapidNaming/blasykkel.png';

import oransjebamse from 'assets/images/rapidNaming/oransjebamse.png';
import oransjegenser from 'assets/images/rapidNaming/oransjegenser.png';
import oransjeeple from 'assets/images/rapidNaming/oransjeeple.png';
import oransjetommel from 'assets/images/rapidNaming/oransjetommel.png';
import oransjesykkel from 'assets/images/rapidNaming/oransjesykkel.png';

import rodbamse from 'assets/images/rapidNaming/rodbamse.png';
import rodgenser from 'assets/images/rapidNaming/rodgenser.png';
import rodeple from 'assets/images/rapidNaming/rodeple.png';
import rodtommel from 'assets/images/rapidNaming/rodtommel.png';
import rodsykkel from 'assets/images/rapidNaming/rodsykkel.png';

import gronnbamse from 'assets/images/rapidNaming/gronnbamse.png';
import gronngenser from 'assets/images/rapidNaming/gronngenser.png';
import gronneple from 'assets/images/rapidNaming/gronneple.png';
import gronntommel from 'assets/images/rapidNaming/gronntommel.png';
import gronnsykkel from 'assets/images/rapidNaming/gronnsykkel.png';

import {normingGrade234Images, normingGrade567YouthAdultImages} from './assets';
import {TYPES} from '../../constants/index';

const images = {
	greyteddy: grabamse,
	greysweater: gragenser,
	greyapple: graeple,
	greythumb: gratommel,
	greybike: grasykkel,
	blueteddy: blabamse,
	bluesweater: blagenser,
	blueapple: blaeple,
	bluethumb: blatommel,
	bluebike: blasykkel,
	orangeteddy: oransjebamse,
	orangesweater: oransjegenser,
	orangeapple: oransjeeple,
	orangethumb: oransjetommel,
	orangebike: oransjesykkel,
	redteddy: rodbamse,
	redsweater: rodgenser,
	redapple: rodeple,
	redthumb: rodtommel,
	redbike: rodsykkel,
	greenteddy: gronnbamse,
	greensweater: gronngenser,
	greenapple: gronneple,
	greenthumb: gronntommel,
	greenbike: gronnsykkel,
};

class Test extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currentStep: 0,
		};
	}

	componentWillReceiveProps(newProps) {
		if (newProps.currentStep !== this.props.currentStep) {
			this.startNewTask(newProps.currentStep);
		}
	}

	componentDidMount() {}

	startNewTask = (taskNumber) => {
		this.setState({
			currentStep: taskNumber,
		});
	};

	getImage = (color, item) => {
		if (this.props.ageGroup >= 2 && this.props.ageGroup <= 4) {
			if (normingGrade234Images[color + item])
				return normingGrade234Images[color + item];
		} else if (this.props.ageGroup >= 5) {
			if (normingGrade567YouthAdultImages[color + item])
				return normingGrade567YouthAdultImages[color + item];
		} else if (
			this.props.testKeyType === TYPES.ADULT_FOLLOWUP ||
			this.props.testKeyType === TYPES.YOUTH_FOLLOWUP
		) {
			if (normingGrade567YouthAdultImages[color + item])
				return normingGrade567YouthAdultImages[color + item];
		} else {
			if (images[color + item]) return images[color + item];
		}
		console.error('Item ' + color + item + ' not found');
		return null;
	};

	getCurrentPosition = (rows, step) => {
		const rowStartIndexes = [];
		let totalItems = 0;

		rows.forEach((row) => {
			rowStartIndexes.push(totalItems);
			totalItems += row.length;
		});

		if (!totalItems) {
			return {
				currentRow: 0,
				currentItem: 0,
				rowStartIndexes,
			};
		}

		const safeStep = Math.min(Math.max(step, 0), totalItems - 1);
		let currentRow = 0;

		for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
			if (safeStep < rowStartIndexes[rowIndex] + rows[rowIndex].length) {
				currentRow = rowIndex;
				break;
			}
		}

		return {
			currentRow,
			currentItem: safeStep - rowStartIndexes[currentRow],
			rowStartIndexes,
		};
	};

	render() {
		const {currentStep} = this.state;
		const {testKeyType} = this.props;

		const selectedTest =
			this.props.ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP
				? getNormingRapidNaming
				: getRapidNaming;
		const isNormingTest =
			this.props.ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		const steps = selectedTest(this.props.ageGroup).getAnswers();
		const {currentRow, rowStartIndexes} =
			this.getCurrentPosition(steps, currentStep);
		const getItemNumber = (rowIndex, index) =>
			rowStartIndexes[rowIndex] + index + 1;

		const row = steps[currentRow] || null;
		const previousRow = steps[currentRow - 1] || null;
		const nextRow = steps[currentRow + 1] || null;

		return (
			<div className="ScrollingTest">
				<div className="row previous">
					{previousRow &&
						previousRow.map((item, index) => (
							<p key={index} className={`item`}>
								<img
									src={this.getImage(item.color, item.item)}
									alt={`A ${item.color} ${item.item}`}
								/>
								{!isNormingTest &&
									getItemNumber(currentRow - 1, index)}
							</p>
						))}
				</div>
				<div className="row">
					{row &&
						row.map((item, index) => (
							<p key={index} className="item">
								<img
									src={this.getImage(item.color, item.item)}
									alt={`A ${item.color} ${item.item}`}
								/>
								{!isNormingTest &&
									getItemNumber(currentRow, index)}
							</p>
						))}
				</div>
				<div className="row next">
					{nextRow &&
						nextRow.map((item, index) => (
							<p key={index} className={`item`}>
								<img
									src={this.getImage(item.color, item.item)}
									alt={`A ${item.color} ${item.item}`}
								/>
								{!isNormingTest &&
									getItemNumber(currentRow + 1, index)}
							</p>
						))}
				</div>
			</div>
		);
	}
}

export default Test;
